import PropTypes from "prop-types";

function SelfServiceDesktop({ config }) {
  return (
    <iframe
      width={"100%"}
      height={"100%"}
      src="https://mtrix-padsales-main.mtrix.com.br/#/self-service"
    ></iframe>
  );
}

SelfServiceDesktop.defaultProps = {
  app: null,
  config: {},
};

SelfServiceDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SelfServiceDesktop;
